// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-location-section[data-v-7bea1908]{padding:30px 0;position:relative;z-index:2}@media(min-width:992px){.user-location-section[data-v-7bea1908]{padding:40px 0}}.user-location-form[data-v-7bea1908]{margin:0 auto;max-width:645px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
